import React, { Fragment, useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactHtmlParser from "react-html-parser";
import moment from 'moment';
import { Colxx } from '../../components/common/CustomBootstrap';
import {
  Card,
  CardBody,
  CardTitle,
  Badge,
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
} from 'reactstrap';
import {
  gAPI_TicketsRecording_id,
  postAPI_Ticket_SendText,
} from '../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../helpers/AxiosAPI';
import Select from 'react-select';
import IntlMessages from '../../helpers/IntlMessages';
import { NotificationManager } from '../../components/common/react-notifications';
import QuickReplyList from '../../views/app/pages/tickets/components/QuickReplyList';
import Masking from '../../data/Masking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faFilePdf, faFileAlt, faFileDownload } from '@fortawesome/free-solid-svg-icons';
const StatusOptionMissed = [
  // { value: "PendingBusiness", label: "Pending with Business" },
  // { value: "PendingBookmebob", label: "Pending with Myma.ai" },
  { value: 'Pending', label: 'Assigned' },
  { value: "AssignBusiness", label: "Assign to Business" },
  { value: "AssignBookmebob", label: "Assign to Myma.ai" }
]
const TicketVisitor = ({
  item,
  handleStatusClicked,
  conversation,
  recordingurl,
  transcript,
  handleMaskClick,
  isMasked,
  hideButton = false,
  isMissingUrl,
  toggleTicket
}) => {
  // const [url, setUrl] = useState(recordingurl);
  // const [conv, setConv] = useState(conversation);
  const [visible, setVisible] = useState(false);
  const [qrVisible, setQRVisible] = useState(false);
  const [messageContent, setMessageContent] = useState('');
  const toggle = () => {
    setVisible(!visible);
  };
  const toggleQR = () => {
    setQRVisible(!qrVisible);
  };
  const handleChange = (e) => {
    setMessageContent(e.target.value);
  };
  const handleSendTextSubmit = () => {
    let data = {
      message: messageContent,
      recipent: conversation.visitor.phoneNumber,
    };

    AxiosAPI({
      method: 'post',
      url: `${postAPI_Ticket_SendText}`,
      data,
    }).then(
      (res) => {
        toggle();
        NotificationManager.success(
          '',
          'Message sent.',
          3000,
          null,
          null,
          'success'
        );
      },
      (error) => {
        console.log(error);
      }
    );
  };

  // function generateRandomColor() {
  //   var arr = [
  //     'primary',
  //     'secondary',
  //     'info',
  //     'success',
  //     'warning',
  //     'danger',
  //     'light',
  //     'dark',
  //   ];
  //   return arr[Math.floor(Math.random() * arr.length)];
  // }
  return (
    <Fragment>
      {/* {isMissingUrl &&
        <Card className="mb-4">
          <CardBody className="mt-0">
            <CardTitle className="mt-0">Actions </CardTitle>
            <Fragment>
              <Button
                color="primary"
                outline
                onClick={toggleTicket}
                style={{ borderRadius: '6px' }}
                className="mr-1 mb-1"
              >
                <IntlMessages id="Convert to Ticket" />
              </Button>
              <Button
                color="primary"
                outline
                onClick={() => handleStatusClicked(item)}
                style={{ borderRadius: '6px' }}
                className="mr-1 mb-1"
              >
                Change Ticket Status
              </Button>
            </Fragment>
          </CardBody>
        </Card>
      } */}
      <Card style={{ overflow: 'scroll', scrollbarColor: 'darkgrey white' }} className={`${(hideButton !== undefined && hideButton === true) ? "cardHeightTickets " : "cardHeightTickets  con-ticket-height"}`}>
        <CardBody>
          <div className="scroll">
            {/* <PerfectScrollbar
        className="scroll coversation-list"
        option={{ suppressScrollX: true, wheelPropagation: true }}
      > */}
            <div className="d-flex">
              <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                Ticket ID:
              </p>
              {item.ticketId}
              <div
                style={{ cursor: 'pointer', marginLeft: 5, color: 'blue' }}
                onClick={() => {
                  navigator.clipboard.writeText(item.ticketId);
                }}
              >
                {' '}
                Copy
              </div>
            </div>

            <div className="d-flex">
              <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                Created:
              </p>
              {moment(item.creationTime).format('dddd, DD MMMM YYYY')} at{' '}
              {moment(item.creationTime).format('h:mm a')}
            </div>
            <div className="d-flex">
              <p className='font-weight-medium mb-0 text-semi-muted ticket-info-spacing'>
                Title:
              </p>
              {item.title}
            </div>
            <div className="d-flex">
              <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                {isMissingUrl ? "Notes:" : "Messages:"}
              </p>
            </div>

            {item.notes.map((note, index) => {
              return (
                <Fragment key={index}>
                  {note.split('<br />').map(function (item, key) {
                    return (
                      <div className="d-flex visitor-note" key={key}>
                        {item.split(":").includes("Email") || item.split(":").includes("Phone Number") ?
                          <p>
                            {item.split(":").includes("Email") &&
                              <p>{item.split(":")[0]}: {isMasked !== "true" ? <Masking input={item.split(":")[1]} inputType={"email"}></Masking> : item.split(":")[1]} <span className="text-muted ml-1" onClick={() => handleMaskClick()} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={isMasked === "true" ? faLock : faLockOpen} className="fa" /></span></p>
                            }
                            {item.split(":").includes("Phone Number") &&
                              <p>{item.split(":")[0]}: {isMasked !== "true" ? <Masking input={item.split(":")[1]} inputType={"mobile"} number={4}></Masking> : item.split(":")[1]} <span className="text-muted ml-1" onClick={() => handleMaskClick()} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={isMasked === "true" ? faLock : faLockOpen} className="fa" /></span></p>
                            }
                          </p> :
                          <p>{ReactHtmlParser(item)}</p>}
                        <br />
                      </div>
                    );
                  })}{' '}
                  {<br />}
                </Fragment>
              );
            })}
            {item.statusNotes !== null && item.statusNotes.map((note, i) => {
              return (
                <Fragment key={i}>
                  <div className="d-flex visitor-note">
                    <p>
                      <p className='font-weight-medium mb-0 ticket-info-spacing'>
                        {moment(note.createdDate).format('dddd, DD MMMM YYYY')} at{' '}
                        {moment(note.createdDate).format('h:mm a')}
                      </p>
                      <p>{ReactHtmlParser(note.text)}</p>
                    </p>
                  </div>
                  {<br />}
                </Fragment>
              )
            })}
            {item.digitalSignature !== undefined && item.digitalSignature !== null && item.digitalSignature !== "" && (
              <Fragment>
                <hr />
                <div className="d-flex">
                  <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                    Digital Signature:
                  </p>
                  <p className='ml-2 mr-2'>
                    <img src={item.digitalSignature} alt="" style={{ height: "65px" }} />
                  </p>
                </div>
              </Fragment>
            )}
            {item.attachments !== undefined && item.attachments !== null && item.attachments.length > 0 && (
              <Fragment>
                <hr />
                <div className="d-flex">
                  <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                    Attachments:
                  </p>
                  {item.attachments.map((file, i) =>
                  (
                    <p className='ml-2 mr-2'>
                      {file.includes("docx") || file.includes("pdf") || file.includes("doc") ?
                        (
                          <Fragment>
                            <span>
                              <FontAwesomeIcon icon={file.includes("pdf") ? faFilePdf : faFileAlt} className="fa" style={{ fontSize: '4rem', marginLeft: "0.4rem", color: "#8f8f8f !important" }} />
                            </span><br />
                            <a href={file} target="_blank" rel="noopener noreferrer" className='ml-2'>
                              <i className="simple-icon-cloud-download" style={{ fontSize: "1.2rem" }}></i>
                            </a>
                          </Fragment>
                        ) :
                        (
                          <Fragment>
                            <span>
                              <img src={file} alt="" style={{ width: "70px", height: "65px" }} />
                            </span><br />
                            <a href={file} target="_blank" rel="noopener noreferrer" className='ml-2'>
                              <i className="simple-icon-cloud-download" style={{ fontSize: "1.2rem" }}></i>
                            </a>
                          </Fragment>
                        )
                      }
                    </p>
                  ))}
                </div>
              </Fragment>
            )}

            <hr />
            <div className="d-flex">
              <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                Source:
              </p>
              <p style={{ textTransform: "capitalize" }}>{item.source === "BobDashboard" ? "Dashboard" : item.source.toLowerCase()}</p>
            </div>
            <div className="d-flex">
              <p className="font-weight-medium mb-0 text-semi-muted ticket-info-spacing">
                Status:
              </p>
              <div
                style={{ cursor: 'pointer', color: 'blue' }}
                onClick={() => handleStatusClicked(item)}
              >
                {StatusOptionMissed.filter((i) => i.value === item.status).length > 0 ?
                  StatusOptionMissed.filter((i) => i.value === item.status).map(i => i.label) :
                  item.status}
              </div>
            </div>

            {hideButton !== undefined && hideButton === true ? null : <Row className="mt-3">
              <Colxx xxs="12">
                <Button
                  size="xs"
                  color="primary"
                  onClick={() => handleStatusClicked(item)}
                >
                  Update Status
                </Button>
                <Button
                  size="xs"
                  color="secondary"
                  className="ml-2"
                  onClick={() => handleStatusClicked(item)}
                >
                  Add Notes
                </Button>
              </Colxx>
            </Row>}

            {/* <hr />

        <div className="d-flex ticket-info-requester-title">
          Types :
        </div>
        <div className="d-flex">
          {item.tags.map((tag, index) => {
            return (
              <Fragment>
                {' '}
                <Badge color={generateRandomColor()}>{tag}</Badge>{' '}
              </Fragment>
            );
          })}
        </div> */}

            {/* <hr /> */}

            {/* <div className="d-flex ticket-info-requester-title">
          Requester
        </div>

        <div className="d-flex">
          {item.requesterName}<br />
          {item.requesterPhoneNumber}
          <br />
          {item.requesterEmail}
          {/* {conversation.visitor && conversation.visitor.contactId ? conversation.visitor.contactId : ''} */}
            {/* </div> */}
            <hr />
            {recordingurl !== '' && (
              <Row>
                <Colxx xxs="12">
                  <audio
                    src={recordingurl}
                    controls
                    style={{ width: '100%' }}
                  ></audio>
                </Colxx>
              </Row>
            )}
            {transcript !== '' && (
              <Fragment>
                <div className="d-flex ticket-info-requester-title">
                  Customer Transcript
                </div>
                <Row>
                  <Colxx xxs="12">
                    <Input type="textarea" name="transcript" value={transcript} />
                  </Colxx>
                </Row>
              </Fragment>
            )}
            {item.requesterPhoneNumber !== '' &&
              item.source === 'Phone' &&
              (item.requesterPhoneNumber.startsWith('+6422') ||
                item.requesterPhoneNumber.startsWith('+6427') ||
                item.requesterPhoneNumber.startsWith('+6421') ||
                item.requesterPhoneNumber.startsWith('+6428') ||
                item.requesterPhoneNumber.startsWith('+6429')) && (
                <Fragment>
                  <Row className="mt-3">
                    <Colxx xxs="12">
                      <Button
                        color="primary"
                        className="default mb-2"
                        onClick={() => toggle()}
                        style={{ width: '50%' }}
                      >
                        Send a Text
                      </Button>
                    </Colxx>
                  </Row>
                </Fragment>
              )}
            {item.requesterPhoneNumber !== '' && item.source === 'Phone' && (
              <Fragment>
                <Row className="mt-3">
                  <Colxx xxs="12">
                    <Button
                      color="primary"
                      disabled={true}
                      className="default mb-2"
                      style={{ width: '50%' }}
                    >
                      Call Back
                    </Button>
                  </Colxx>
                </Row>
              </Fragment>
            )}
            {/* </PerfectScrollbar> */}
            <Row>
              <Colxx xxs="12">
                <Modal isOpen={visible} toggle={toggle}>
                  <ModalHeader toggle={toggle}>
                    Pick a quick reply or type your message
                  </ModalHeader>
                  <ModalBody>
                    {/* <Row className="mb-2">
                <Colxx xxs="12">
                  <Button
                    color="primary"
                    className="mb-2"
                    onClick={toggleQR}
                  >
                    Templates
                  </Button>
                </Colxx>
              </Row> */}
                    <Row>
                      <Colxx xxs="12">
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>Message</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Input
                              name="ticketMessage"
                              onChange={handleChange}
                              type="textarea"
                              value={messageContent}
                            />
                          </Colxx>
                        </Row>
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>Quick Replies</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              name="quickreply"
                            />
                          </Colxx>
                        </Row>
                        <Row>
                          <Colxx xxs="3">
                            <Button
                              color="primary"
                              className="mb-2"
                              onClick={handleSendTextSubmit}
                            >
                              <IntlMessages id="forms.submit" />
                            </Button>
                          </Colxx>
                        </Row>
                      </Colxx>
                    </Row>
                  </ModalBody>
                </Modal>
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <Modal isOpen={qrVisible} toggle={toggleQR}>
                  <ModalHeader toggle={toggleQR}>Templates</ModalHeader>
                  <ModalBody>
                    <Row>
                      <Colxx xxs="12">
                        <Row className="mb-2">
                          <Colxx xxs="12">
                            <label>Message</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Input
                              name="ticketMessage"
                              onChange={handleChange}
                              type="textarea"
                              value={messageContent}
                            />
                          </Colxx>
                        </Row>
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>Quick Replies</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              name="quickreply"
                            />
                          </Colxx>
                        </Row>
                      </Colxx>
                    </Row>
                  </ModalBody>
                </Modal>
              </Colxx>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default TicketVisitor;
